module.exports = __webpack_public_path__ + "static/media/marion-jean.0f1da313.jpg";